import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/app-logo-white.png")